module.exports = __webpack_public_path__ + "static/media/Koch Minerals.97431e4f.svg";